// src/appCheck.js
//
// APP CHECK - and an honest account of why it is not on.
//
// functions/index.js submitApplication refuses any call without context.app, deliberately and as its
// FIRST act: the application form is the one door on this platform that faces the open internet, and
// a form anybody can POST to is a form that fills every officer's desk from a script. That gate does
// not move to make a page work.
//
// App Check is NOT initialised on this site (S-8 in the complete breakdown, 2026-09-19). Turning it
// on needs a reCAPTCHA site key that only the project owner can create in the Firebase console - it
// is not a value this repository can hold or invent. So:
//
//   * If REACT_APP_APPCHECK_SITE_KEY is set at build time, App Check initialises and applications
//     are accepted.
//   * If it is not, App Check does not initialise, and appCheckReady() returns false. The form SAYS
//     SO before he fills it in, rather than letting a man type his whole work history and then
//     handing him 'failed-precondition' at the end.
//
// The steps to set the key live in the console handoff. Nothing here degrades to "submit anyway".

// PROVIDER: reCAPTCHA ENTERPRISE, not v3 (2026-09-22, task list section 337). The v3 route needs a
// SECRET key pasted into the Firebase console; Enterprise needs only the public site key, because App
// Check verifies through the project itself. Key: 'Labor On The Record - App Check (web)', created in
// project yardmaster-claims-system, score-based, five domains. The site key ships in the bundle like
// the Firebase apiKey - it is public by design.
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { app } from './firebase';

const SITE_KEY = (process.env.REACT_APP_APPCHECK_SITE_KEY || '').trim();

let started = false;

export function appCheckSiteKeyPresent() {
  return SITE_KEY.length > 0;
}

export function startAppCheck() {
  if (started || !SITE_KEY) return false;
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
    started = true;
    return true;
  } catch (e) {
    // A key that the console has not finished registering throws here. Say what happened; do not
    // pretend App Check is running, because the callable will disagree a minute later.
    console.error('App Check did not start:', e);
    return false;
  }
}

export function appCheckReady() {
  return started;
}
